module.exports = __webpack_public_path__ + "img/logo-inverted.652f6ece.svg";